import { render, staticRenderFns } from "./minute.vue?vue&type=template&id=74fec853&scoped=true&"
import script from "./minute.vue?vue&type=script&lang=js&"
export * from "./minute.vue?vue&type=script&lang=js&"
import style0 from "./minute.vue?vue&type=style&index=0&id=74fec853&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fec853",
  null
  
)

export default component.exports